import React from 'react'
import escapeRegExp from 'lodash.escaperegexp'
import debounce from 'lodash.debounce'
import { translate } from 'react-i18next'
import { compose, pure } from 'recompose'
import Autosuggest from 'react-autosuggest'
import styles from './schoolSearchComponent.scss'
import FloatLabelInput from '../floatLabelInput/floatLabelInputComponent.js'

export type Values = {
  suggestions: Array<any>,
  startingList: Array<any>
}

export type Callbacks = {
  updateSuggestions: () => any
}

type Props = Values & Callbacks

export const getSuggestions = (value, startingList) => {
  const escapedValue = escapeRegExp(value.trim())

  if (escapedValue === '') {
    return []
  }

  const regex = new RegExp('^' + escapedValue, 'i')
  const regexReturn = startingList.filter(item => regex.test(item.name))
  return regexReturn
}

export const renderSuggestion = suggestion =>
  <span>
    {suggestion.name}
  </span>

export const getSuggestionValue = suggestion => suggestion.name

export const renderInput = inputProps => {
  let input = {
    ...inputProps
  }
  return <FloatLabelInput input={input} />
  // return <FloatLabelInput input={input} meta={input.meta} />
}

export function SchoolSearch (props: Props) {
  // const { t } = props
  // Autosuggest will pass through all these props to the input.
  const inputProps = {
    name: props.name,
    type: 'text',
    label: props.label,
    placeholder: props.placeholder,
    value: props.input.value,
    meta: props.meta,
    onChange: (event, { newValue }) => props.input.onChange(newValue),
    onBlur: (event, { highlightedSuggestion }) => {
      if (highlightedSuggestion !== null && props.onSuggestionSelected) {
        props.onSuggestionSelected(highlightedSuggestion)
      }
    }
  }

  // Finally, render it!
  return (
    <Autosuggest
      suggestions={props.suggestions}
      onSuggestionsFetchRequested={({ value }) =>
        props.updateSuggestions(getSuggestions(value, props.startingList))}
      onSuggestionsClearRequested={() => {
        props.updateSuggestions([])
      }}
      getSuggestionValue={getSuggestionValue}
      renderSuggestion={renderSuggestion}
      renderInputComponent={renderInput}
      inputProps={inputProps}
      theme={styles}
      id={`${props.name}-autosuggest`}
      onSuggestionSelected={(
        e,
        { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }
      ) => {
        if (props.setSchoolEmpty) {
          props.setSchoolEmpty()
        }
        if (props.onSuggestionSelected) {
          e.preventDefault()
          props.onSuggestionSelected(suggestion)
        }
      }}
      focusInputOnSuggestionClick={false}
    />
  )
}

export default compose(pure, translate())(SchoolSearch)



// WEBPACK FOOTER //
// ./src/forms/components/schoolSearch/schoolSearchComponent.js